import { RootState } from "./store";

export const cameraTargetPointSelector = (state: RootState) => state.camera.targetPoint;
export const cameraReturnPointSelector = (state: RootState) => state.camera.returnPoint;
export const cameraShowDebugBoundarySelector = (state: RootState) => state.camera.showBoundaryDebug;